import { createClient } from '@supabase/supabase-js'

// .env файлаас утгуудыг уншина
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Supabase клиент үүсгэж экспортлох
export const supabase = createClient(supabaseUrl, supabaseAnonKey)